import { stringify } from "qs";
import request from "../request";
import { url } from "../service-utils";

export async function getLessonList(params) {
  return request(
    `${url.doubleTeacherClass}/live/lesson/list/page?${stringify(params)}`
  );
}

export async function deleteLesson(params) {
  return request(`${url.doubleTeacherClass}/live/lesson/delete?${stringify(params)}`, {
    method: "DELETE",
  });
}

